import * as store from './store';

let interval;
export let intervalIsActive;

startInterval();

export function startInterval() {
    intervalIsActive = true;
    interval = setInterval(() => {
        let index = store.getters.getActiveIndex();

        index = index < store.getters.getValues().length - 1 ? index + 1 : 0;
        switchActiveIndex(index);
    }, store.getters.getDelay());
}

export function stopInterval() {
    intervalIsActive = false;
    clearInterval(interval);
}

export function switchActiveIndex(index) {
    stopInterval();
    startInterval();
    store.setters.setActiveIndex(index);
}